import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import MiniDrawer from "./../MiniDrawer";
import Footer from "../components/Footer";
import { IonButton, IonGrid, IonRow, IonCol, IonItem, IonLabel, IonInput, IonAlert, IonModal } from '@ionic/react';
import { Card, CardContent, } from "@material-ui/core";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModules } from "@ag-grid-community/all-modules";
import { TagSelector } from "../components/TagSelector.js";

import "./Page.css";
import "./../App.css";

import { getTimestamp } from "../components/timeStamp.js";

import { useRecoilState } from "recoil";
import { advisorAtom } from "../atom.js";
import { getLocalStorage } from "../components/localstorage.js";

const Tags = (props) => {

  const [advisor_atom, setAdvisorAtom] = useRecoilState(advisorAtom);

  const [recoilFetched, setRecoilFetched] = useState(false);

  const [newPassword, setNewPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")

  const [customTags, setCustomTags] = useState([]);
  const taxTypes = [{ type: "Expense", value: 'E' }, { type: "Income", value: "I" }]
  const [selectedTaxType, setSelectedTaxType] = useState('E')
  const [inputTagName, setInputTagName] = useState("")
  const [editingTagId, setEditingTag] = useState(0)
  const [inputTagTitle, setInputTagTitle] = useState("")

  const [inputTagDescription, setInputTagDescription] = useState("")
  const [showIncomeExpense, setShowIncomeExpense] = useState(false)
  const [showTagSelector, setShowTagSelector] = useState(false)
  const [taxCat, setTaxCat] = useState(null)
  const [taxCats, setTaxCats] = useState([])
  const [tagActionCaption, setTagActionCaption] = useState("Add")
  const [showDeleteTag, setShowDeleteTag] = useState({ show: false, id: 0, tagName: null, tagType: null })
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);

  const styles = {
    cardStyle: {
      marginTop: 10,
      //minWidth: 800,
      padding: "none",
      position: "relative",
      height:'100%'
    },
    divCardStyle: {
      marginTop: 10,
      //minWidth: 800,
      padding: "none",
      position: "relative",
      display: "flex"
    },
    addAdvisorButton: {
      paddingVertical: 12,
      width: 150,
      height: 48,
      borderRadius: 4,
      backgroundColor: "#3f90b0",
      color: "#ffffff",
      position: "absolute",
      margin: "auto",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      marginRight: 10
    },
    buttonContainer: {
      paddingVertical: 12,
      width: 150,
      height: 48,
      borderRadius: 4,
      backgroundColor: "#3f90b0",
      color: "#ffffff"
    },
    smallButtonContainer: {
      width: 150,
      borderRadius: 4,
      backgroundColor: "#3f90b0",
      color: "#ffffff"
    },
    disabledButton: {
      width: 150,
      backgroundColor: "rgba(0, 0, 0, 0.12)",
      color: "rgba(0, 0, 0, 0.26)"
    },
    infoIcon: {
      height: 15,
      width: 15,
      color: "#3f90b0",
      cursor: "pointer"
    },
    planCardContainer: {
      width: "50%",
      height: 100,
      padding: 20,
      textAlign: "center"
    },
    planCardContent: {
      height: "100%",
      maxWidth: 200,
      margin: "auto",
      cursor: "pointer"
    }
  };

  const constants = {

    customTagsColumnDefs: [

      {
        headerName: "Title",
        field: "title",
        resizable: true,
        cellStyle: { textAlign: "left" },
        width: 200
      },
      {
        headerName: "Description",
        field: "description",
        resizable: true,
        cellStyle: { textAlign: "left" },
        width: 350
      },
      {
        headerName: "Type",
        field: "type",
        resizable: false,
        cellStyle: { textAlign: "left" },
        width: 120,
        valueGetter: params => params.data.type === "E" ? "Expense" : "Income"
      },
      {
        headerName: "Tax category",
        field: "tax_cat",
        resizable: true,
        cellStyle: { textAlign: "left" }
      },
      {
        headerName: "Tagname",
        field: "tagname",
        resizable: true,
        cellStyle: { textAlign: "left" },
        width: 150
      },
      {
        headerName: "Action",
        filter: false,
        sortable: false,
        resizable: false,
        cellStyle: { textAlign: "left" },
        cellRendererFramework: params => {
          return (
            <div>
              <button className="gridButton" onClick={() => {
                setEditingTag(params.data.id)
                setInputTagName(params.data.tagname)
                setInputTagTitle(params.data.title)
                setInputTagDescription(params.data.description)
                setSelectedTaxType(params.data.type)
                setTaxCat(params.data.tax_cat_id)
                setTagActionCaption('Update')
              }}>
                Edit
              </button>
              <button style={{ marginLeft: 5 }} className="gridButton" onClick={() => {
                delCustomTag(params.data.tagname, params.data.type)
                setShowDeleteTag({ show: true, id: params.data.id, title: params.data.title, tax_cat_id: params.data.tax_cat_id })
              }}>
                Delete
              </button>
            </div>

          );
        }
      }

    ]
  };

  const getCustomTags = () => {

    const token = advisor_atom.agentToken

    console.log('get tags')

    fetch(`https://${global.api_url}/agent/getCustomTags.php?ts=${getTimestamp()}`,
      {
        method: "GET",
        headers: { token, partnerId: "775dbaef-6ac1-49a1-bfea-9ce82b8dbd2a" }
      })
      .then(res => res.json())
      .then(json => {
        console.log(json)
        setCustomTags(json)

        fetch(
          `https://${global.api_url}/agent/getTaxCategories.php?ts=${getTimestamp()}`,
          {
            method: "GET",
            headers: { token, partnerId: "775dbaef-6ac1-49a1-bfea-9ce82b8dbd2a" }
          }
        )
          .then(res => res.json())
          .then(json => {

            console.log(json)

            if (json.error) {
              if (json.error === "unauthorized") {
               // props.history.push("/logout/logout");
              }
            } else {
              // remove items from json.tax_categories where tax_cat_id starts with 'c'
              let filtered = json.tax_categories.filter(item => item.id.startsWith('c') === false);
              setTaxCats(filtered)
            }
          });

      });
  }

  const addCustomTag = () => {

    const token = advisor_atom.agentToken

    fetch(`https://${global.api_url}/agent/addCustomTag.php?ts=${getTimestamp()}`, {
        method: "POST",
        headers: { token },
        body: JSON.stringify({
            id: editingTagId, tagname: inputTagName, title: inputTagTitle, description: inputTagDescription, tax_cat_id: taxCat, type: selectedTaxType
        })
    })
        .then(res => res.json())
        .then(json => {

          console.log('add tag', json)

            if (json.status === "success") {
                getCustomTags()
                setEditingTag(0)
                setTagActionCaption('Add')
            } else {
                alert(json.message);
            }
        });
}

const delCustomTag =  (id, title, tax_cat_id) => {
    const token = advisor_atom.agentToken
    fetch(`https://${global.api_url}/agent/addCustomTag.php?ts=${getTimestamp()}`, {
        method: "POST",
        headers: { token },
        body: JSON.stringify({
            id, title, tax_cat_id, delete: true
        })
    })
        .then(res => res.json())
        .then(json => {

            console.log(json)

            if (json.status === "success") {
                getCustomTags()                      
            } else {
                alert(json.message);
            }
        });
}

  useEffect(() => {
    if (JSON.stringify(advisor_atom) === "{}" || !recoilFetched) {
      let userState = getLocalStorage();
      if (!userState.agentToken) {
        localStorage.clear()
        props.history.push("/logout")
      }
      else {
        setAdvisorAtom(userState)
        setRecoilFetched(true);
        getCustomTags();
      }
    }
  }, [advisor_atom, props.history, recoilFetched, setAdvisorAtom]);


  const incomeExpenseModal = () => {
    return (
      <IonModal
        isOpen={showIncomeExpense}
        onDidDismiss={() => setShowIncomeExpense(false)}
        className="income-expense-selector-modal"
      >

        <div style={{ overflow: 'auto', borderRadius: 5, paddingBottom: 5 }}>
          <h4 style={{ paddingLeft: 10, color: "#3f90b0" }}>Transaction type</h4>
          {taxTypes !== [{}] && taxTypes.map((type, index) => {

            return <div className="income-expense-modal-item" key={index} onClick={() => {
              setSelectedTaxType(type.value)
              setShowIncomeExpense(false)
            }}>
              <div className="income-expense-tag-item">{type.type}</div>
            </div>
          })}
        </div>
      </IonModal>

    )
  }

  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
    params.api.sizeColumnsToFit();
  };



  const services = {
    renderService: {
      displayMainScreen: () => {
        if (recoilFetched) {
          return (<>
            <div
              style={{
                height: '100%',
                flexDirection: "row",
                display: "flex",
                paddingLeft: 0,
                paddingBottom: 7
              }}
            >



              <IonGrid fixed={true} style={{ "--ion-grid-width-md": '100%', "--ion-grid-width-lg": '100%', "--ion-grid-width-xl": '600px', height:'100%' }}>

                <IonRow style={{height:'100%'}}>


                  <div style={{ paddingRight: 10, height:'100%', width:'100%' }}>
                    {incomeExpenseModal()}

                    <TagSelector
                      taxCats={taxCats}
                      type={selectedTaxType}
                      show={showTagSelector.show}
                      onDidDismiss={() => setShowTagSelector(false)}
                      onClick={(item) => {
                        setTaxCat(item.id);
                        setShowTagSelector(false)
                      }} />

                    <Card style={styles.cardStyle}>
                      <CardContent style={{height:'100%', padding:0 }}>
                        <IonGrid style={{height:'100%'}}>
                          <IonRow style={{ height: '100%' }}>

                            <IonCol style={{ textAlign: "left" }}>
                              <h3 style={{marginTop:5, marginBottom:5}}>
                                Default custom tags
                              </h3>
                              <div className={`ag-theme-alpine grid-container`} style={{ height: "calc(100% - 200px)" }}>
                                <AgGridReact

                                  modules={AllCommunityModules}
                                  rowData={customTags}
                                  columnDefs={constants.customTagsColumnDefs}
                                  pagination={false}
                                  rowHeight={30}
                                  onGridReady={onGridReady}
                                  suppressNoRowsOverlay={true}
                                />
                              </div>

                              <div>
                                <IonRow style={{ height: '90%', minWidth: 780 }}>

                                  <IonCol>


                                    <IonItem
                                      // lines = "full"
                                      className="custom-tags-input"
                                    // style = {{ "--padding": 0, marginRight: 5}}
                                    >
                                      <IonLabel position="stacked" className="custom-tag-style"><h2>Title</h2></IonLabel>
                                      <IonInput
                                        value={inputTagTitle}
                                        placeholder="Title"
                                        onIonChange={(e) => { setInputTagTitle(e.target.value) }}
                                        readonly={tagActionCaption === "Update"}
                                        // className="my-tax-selector-input left-indent"
                                        className="custom-filter-payments"
                                        style={{ paddingLeft: 0, }} >

                                      </IonInput>
                                    </IonItem>

                                  </IonCol>


                                  <IonCol>


                                    <IonItem
                                      className="custom-tags-input"
                                      style={{ minWidth: 190 }}
                                    >
                                      <IonLabel position="stacked" className="custom-tag-style"><h2>Transaction type</h2></IonLabel>
                                      <IonInput
                                        value={selectedTaxType ? taxTypes.filter(t => t.value == selectedTaxType)[0].type : "Choose a transaction type"} readonly
                                        onClick={(e) => { setShowIncomeExpense(true) }}

                                        // className="my-tax-selector-input left-indent"
                                        className="custom-filter-payments"
                                        style={{ paddingLeft: 0, }} >
                                        <div className="my-caret-dropdown-icon" />
                                      </IonInput>
                                    </IonItem>

                                  </IonCol>


                                  <IonCol>

                                    <IonItem className="custom-tags-input" style={{ minWidth: 190 }}  >
                                      <IonLabel position="stacked" className="custom-tag-style" style={{ paddingLeft: 2, }}><h2>Main tax tag</h2></IonLabel>
                                      <IonInput disabled={selectedTaxType.length === 0} value={taxCats.find(el => el.id === taxCat) ? taxCats.find(el => el.id === taxCat).title : "Select"} readonly onClick={() => {
                                        setShowTagSelector({ show: true, id: "" })
                                        //setTagClickFunction("filterbar")
                                      }}
                                        className="my-tax-selector-input left-indent">
                                        <div className="my-caret-dropdown-icon" />
                                      </IonInput>
                                    </IonItem>

                                  </IonCol>
                                  <IonCol>


                                    <IonItem
                                      className="custom-tags-input"

                                    >
                                      <IonLabel position="stacked"><h2>Description</h2></IonLabel>
                                      <IonInput
                                        value={inputTagDescription}
                                        onIonChange={(e) => { setInputTagDescription(e.target.value) }}
                                        placeholder="Description"
                                        // className="my-tax-selector-input left-indent"
                                        className="left-indent"
                                        style={{ margin: "8px 0px, 0px" }} >

                                      </IonInput>
                                    </IonItem>

                                  </IonCol>

                                  <IonCol>


                                    <IonItem
                                      // lines = "full"
                                      className="custom-tags-input"
                                    // style = {{ "--padding": 0, marginRight: 5}}
                                    >
                                      <IonLabel position="stacked" className="custom-tag-style"><h2>Tagname</h2></IonLabel>
                                      <IonInput
                                        value={inputTagName}
                                        placeholder="Tagname"
                                        onIonChange={(e) => { setInputTagName(e.target.value) }}

                                        // className="my-tax-selector-input left-indent"
                                        className="custom-filter-payments"
                                        style={{ paddingLeft: 0, }} >

                                      </IonInput>
                                    </IonItem>

                                  </IonCol>


                                  <IonCol>

                                    <IonButton
                                      className="ion-button-money"
                                      style={{ paddingTop: 20 }}
                                      onClick={() => {
                                        addCustomTag()
                                      }}>
                                      {tagActionCaption}
                                    </IonButton>

                                    {tagActionCaption === "Update" &&
                                      <IonButton
                                        className="ion-button-money"
                                        style={{ paddingTop: 20 }}
                                        onClick={() => {
                                          setEditingTag(0)
                                          setInputTagName('')
                                          setInputTagTitle('')
                                          setInputTagDescription("")
                                          setSelectedTaxType("E")
                                          setTaxCat(0)
                                          setTagActionCaption('Add')
                                        }}>
                                        Cancel
                                      </IonButton>}

                                  </IonCol>


                                </IonRow>


                                <IonRow>
                                  <IonCol>
                                    <p style={{ fontWeight: '700' }}>Keep the tagname short as this is what shows up in the transaction feed - max length 25 characters but 12 best for mobile. Title and description are used in the tag selector. </p>
                                  </IonCol>
                                </IonRow>

                              </div>


                            </IonCol>
                          </IonRow>
                        </IonGrid>
                      </CardContent>
                    </Card>

                    <IonAlert
                      isOpen={showDeleteTag.show}
                      onDidDismiss={() => setShowDeleteTag({ ...showDeleteTag, show: false })}
                      header={'Delete tag'}

                      message={'Are you sure you want to delete this tag?'}
                      buttons={[
                        {
                          text: 'No',
                          handler: () => {
                            setShowDeleteTag({ ...showDeleteTag, show: false })
                          }
                        },
                        {
                          text: 'Yes, please',
                          handler: () => {
                            //this.saveRule();
                            delCustomTag(showDeleteTag.id, showDeleteTag.title, showDeleteTag.tax_cat_id)
                            setShowDeleteTag({ ...showDeleteTag, show: false })
                          }
                        }
                      ]}
                    />

                  </div>


                </IonRow>

              </IonGrid>

            </div>
          </>)
        }
      },

      displayFooter: () => {
        return <Footer />;
      },
    },
  };

  console.log('render')

  return (
    <React.Fragment>
      <div className="accounts-page-container">
        <MiniDrawer />
        <div className="accounts-page-content">
          {services.renderService.displayMainScreen()}
        </div>
      </div>
      {/* {services.renderService.displayFooter()} */}
    </React.Fragment>
  );
};

export default withRouter(Tags);